// Copyright (c) Microsoft. All rights reserved.

import { Spinner, makeStyles } from '@fluentui/react-components';
import { FC } from 'react';
import { abtisAccentColorValueString, abtisAccentHoverColorValueString, useSharedClasses } from '../../styles';

interface ILoadingProps {
    text: string;
}

const useClasses = makeStyles({
    wrapper: {
        '> span > svg > circle:first-child': {
            stroke: abtisAccentHoverColorValueString,
        },
        '> span > svg > circle:nth-child(2) ': {
            stroke: abtisAccentColorValueString,
        },
    },
});

export const Loading: FC<ILoadingProps> = ({ text }) => {
    const classes = useSharedClasses();
    const classesSpinner = useClasses();
    return (
        <div className={classes.informativeView}>
            <Spinner labelPosition="below" label={text} className={classesSpinner.wrapper} />
        </div>
    );
};
